<script>
export default {
  props: {
    text: {
      type: String,
      default: "Paragraph",
    },
  },
};
</script>

<template>
  <p class="paragraph">{{ text }}</p>
</template>
